// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from "react";

export const ArrowRight = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width={size}
      height={size}
      fill={fill || "none"}
      stroke={stroke}
      strokeWidth="4px"
    >
      <polygon
        xmlns="http://www.w3.org/2000/svg"
        points="13 1.6 35.4 24 13 46.4 12.3 45.6 33.9 24 12.3 2.4 13 1.6"
      />
    </svg>
  );
};
